// extracted by mini-css-extract-plugin
module.exports = {"main":"App_main__3ZkGI","aside":"App_aside__HVdR9","tableSection":"App_tableSection__2qRO3"};